<template>
  <v-dialog max-width="300" persistent v-model="show">
    <v-card>
      <v-date-picker
        v-model="datePicker"
        :min="minDate"
        width="300"
        :reactive="true"
      ></v-date-picker>
      <v-card-actions>
        <v-btn @click="submit" :disabled="!selectionComplete">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DatePicker',
  props: ['minDate'],
  data: () => ({
    show: true,
    datePicker: new Date().toISOString().substr(0, 10)
  }),
  methods: {
    submit() {
      this.$emit('pick', this.datePicker.toString())
    },
    close() {
      this.$emit('close')
    }
  },
  computed: {
    selectionComplete() {
      return this.datePicker
    }
  }
}
</script>

<style scoped></style>
